import React from 'react';
import { useSelector } from 'react-redux';

import { Tabela } from '~/components';
import { t } from '~/helpers';
import {
  dataInRequest,
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/causasManutencoes/actions';

import MyForm from './form';

function CausasManutencoes() {
  const data = useSelector((state) => state.causasManutencoes);

  // Options
  const status = React.useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  // Header tabela
  const header = React.useMemo(
    () => [
      {
        id: 'idcausamanutencao',
        label: t('s.cadastro.causamanutencao.idcausamanutencao'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'descricaocausamanutencao',
        label: t('s.cadastro.causamanutencao.descricaocausamanutencao'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'statuscausamanutencao',
        label: t('s.cadastro.causamanutencao.statuscausamanutencao'),
        converter: status,
        filter: {
          type: 'select',
          options: status,
        },
      },
    ],
    []
  );

  return (
    <Tabela
      read={dataInRequest}
      remove={deleteData}
      state={data}
      header={header}
      headerMobile="idcausamanutencao"
      unique={['idcausamanutencao']}
      form={MyForm}
      findItem={findData}
      recordFilter={recordFiltering}
    />
  );
}

export default CausasManutencoes;
